import { Toaster } from "sonner";
import { Website, Landing, LegalPage } from "./components/site/MarketingSite";

const LEGAL_ROUTES = {
  "/privacy": "privacy",
  "/terms": "terms",
  "/disclosures": "disclosures",
};

function App() {
  let path = window.location.pathname.replace(/\/+$/, "") || "/";

  if (path === "/" || !["/website", "/apply", ...Object.keys(LEGAL_ROUTES)].includes(path)) {
    window.history.replaceState({}, "", `/website${window.location.hash || ""}`);
    path = "/website";
  }

  const page = path === "/apply"
    ? <Landing />
    : LEGAL_ROUTES[path]
      ? <LegalPage slug={LEGAL_ROUTES[path]} />
      : <Website />;

  return (
    <>
      <Toaster position="top-right" richColors closeButton />
      {page}
    </>
  );
}

export default App;